import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { mountTool } from '../main.js';
import {
  initSmoothScroll,
  initFaqAccordion,
  initSignupForm,
  initConfirmedToast,
} from '../landing.js';

import '../ui/styles/variables.css';
import '../ui/styles/base.css';
import '../ui/styles/tool.css';
import '../ui/styles/landing.css';

import landingHTML from '../landing-content.html?raw';

export default function LandingPage() {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    // landingHTML is a build-time static asset imported via Vite ?raw
    container.innerHTML = landingHTML;

    initSmoothScroll();
    initFaqAccordion();
    initSignupForm();
    initConfirmedToast();

    const toolContainer = container.querySelector('#tool-container');
    let handle = null;
    if (toolContainer) {
      handle = mountTool(toolContainer);
    }

    // Wire upgrade CTAs to the pricing page
    container.querySelectorAll('a[href="#upgrade"]').forEach((link) => {
      link.href = '/pricing';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        navigate('/pricing');
      });
    });

    return () => {
      if (handle) {
        handle.destroy();
      }
      container.innerHTML = '';
    };
  }, [navigate]);

  return <div ref={ref} />;
}
